module.exports = __webpack_public_path__ + "img/coverages.4a8032d6.svg";